import Home from "../../components/Home";
import Room from "../../components/Room";

export const routes = [
  {
    key: 1,
    component: Home,
    exact: true,
    path: "/",
  },
  {
    key: 2,
    component: Room,
    exact: false,
    path: "/room",
  },
];
